import React, { useEffect, useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import Constants from "../../data/Constants";
import Utils from "../../utils/index";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import { getUserList } from "../../services/user.service";
import { MdContentCopy } from "react-icons/md";

function Mentees(props) {
  const navigate = useNavigate();
  const [data, setData] = useState(false);
  const [copy, setCopy] = useState(false);
  const { setProgress, setToast, isRefreshed } = useOutletContext();

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        const data = await getUserList({ type: "Mentee,Mentor" }); // no students
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error
          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, [isRefreshed]);

  function CustomRow(props) {
    const { row, index, skipValue } = props;

    return (
      <>
        <TableRow key={row._id}>
          <TableCell>{index + 1 + skipValue}</TableCell>
          <TableCell>
            {row.firstname ? row.firstname + " " + row.lastname : "Not Set"}
          </TableCell>
          <TableCell>{row.email ?? "Not Set"}</TableCell>
          <TableCell>{row.mobile ?? "Not Set"}</TableCell>
          <TableCell>{row.deleted.toString()}</TableCell>
          <TableCell>
            {moment(row.createdAt).format("dddd, MMMM Do YYYY, h:mm a")}
          </TableCell>
          <TableCell>
            <Tooltip title={copy ? "ID Copied!" : "Copy Mentee ID"}>
              <span>
                <CopyToClipboard
                  text={row._id}
                  onCopy={() => {
                    setCopy(true);
                    setTimeout(() => {
                      setCopy(false);
                    }, 2000);
                  }}
                >
                  <IconButton
                    size="small"
                    variant="contained"
                    onClick={() => {}}
                  >
                    <MdContentCopy />
                  </IconButton>
                </CopyToClipboard>
              </span>
            </Tooltip>

            {/* <Tooltip title="Copy Mentee ID">
              <IconButton size="small" variant="contained" onClick={() => {}}>
                <MdContentCopy />
              </IconButton>
            </Tooltip> */}

            <Button
              size="small"
              variant="contained"
              onClick={(e) => {
                navigate("/dashboard/mentees/" + row._id, {
                  state: { mentor: row },
                });
              }}
            >
              View
            </Button>
          </TableCell>
        </TableRow>
      </>
    );
  }

  return (
    <div>
      <Box style={{ width: "100%" }}>
        <TableContainer>
          <div className="flex justify-end gap-5">
            {/* <Button
              variant="outlined"
              className="my-8"
              onClick={(e) => {
                navigate("/dashboard/mentor/edit");
              }}
            >
              Create Mentor
            </Button> */}
          </div>
          <Table size="small">
            <TableHead className="">
              <TableRow className=""></TableRow>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>ID</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Fullname</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Email</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Mobile</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Deactivated
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Created At</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                ? data.map((row, index) => {
                    return (
                      <CustomRow
                        row={row}
                        key={index}
                        index={index}
                        skipValue={0}
                      />
                    );
                  })
                : null}
            </TableBody>
          </Table>
          {/* <div style={{ marginTop: '20px', textAlign: 'center' }} hidden={survey.length != 0}>
                No data with given filters
            </div> */}
        </TableContainer>
      </Box>
    </div>
  );
}

export default Mentees;
